var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import YouTubeIframeLoader from "youtube-iframe";
import PlayerEventBus from "@/EventBuses/ThePlayerEventBus";
var YoutubePlayer = (function (_super) {
    __extends(YoutubePlayer, _super);
    function YoutubePlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.player = _this.$store.state.player;
        _this.YTPlayer = null;
        _this.YTPlayerState = -1;
        return _this;
    }
    YoutubePlayer.prototype.onPlayerReady = function (event) {
        var _this = this;
        this.YTPlayer = event.target;
        this.updateProgress();
        var time_update_interval;
        clearInterval(time_update_interval);
        time_update_interval = setInterval(function () {
            _this.updateProgress();
        }, 300);
    };
    YoutubePlayer.prototype.updateProgress = function () {
        if (!this.YTPlayer.getDuration())
            return;
        var percentageLoaded = this.YTPlayer.getVideoBytesLoaded() * 100;
        this.$store.dispatch("setTime", this.YTPlayer.getCurrentTime());
        this.$store.dispatch("setBuffered", this.YTPlayer.getVideoBytesLoaded() * this.player.duration);
    };
    YoutubePlayer.prototype.created = function () {
        var _this = this;
        var player;
        YouTubeIframeLoader.load(function (YT) {
            player = new YT.Player('youtube-player', {
                height: '225',
                width: '300',
                events: {
                    'onReady': _this.onPlayerReady,
                    'onStateChange': function (val) {
                        _this.YTPlayerState = val.data;
                        _this.$store.dispatch("setDuration", _this.YTPlayer.getDuration());
                    },
                },
                playerVars: {
                    'autoplay': 0,
                    'controls': 0,
                    'rel': 0,
                    'fs': 0,
                }
            });
        });
        PlayerEventBus.$on("seekTo", function (time) {
            if (_this.$store.getters.audio.provider !== "youtube")
                return;
            _this.YTPlayer.seekTo(time);
        });
    };
    YoutubePlayer.prototype.onPositionChange = function () {
        if (this.player.alteringPlaylist)
            return;
        if (this.$store.getters.audio.provider !== "youtube") {
            this.YTPlayer.stopVideo();
        }
    };
    YoutubePlayer.prototype.onAudioChange = function (newAudio, oldAudio) {
        if (oldAudio && (newAudio && (newAudio.id === oldAudio.id)))
            return;
        if (!newAudio)
            return;
        if (newAudio.provider === "youtube") {
            this.YTPlayer.loadVideoById(newAudio.providerId);
            this.YTPlayer.playVideo();
        }
    };
    YoutubePlayer.prototype.onStateChanged = function (newState, oldState) {
        var _this = this;
        if (newState === oldState)
            return;
        if (this.$store.getters.audio && this.$store.getters.audio.provider !== "youtube")
            return;
        this.$nextTick(function () {
            if (newState === 1) {
                _this.YTPlayer.playVideo();
            }
            else {
                if (_this.YTPlayer.getPlayerState() === 1) {
                    _this.YTPlayer.pauseVideo();
                }
            }
        });
    };
    YoutubePlayer.prototype.onYTPlayerStateChange = function (newState) {
        return;
    };
    __decorate([
        Watch("player.position", { immediate: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], YoutubePlayer.prototype, "onPositionChange", null);
    __decorate([
        Watch("$store.getters.audio", { immediate: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], YoutubePlayer.prototype, "onAudioChange", null);
    __decorate([
        Watch("player.state"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], YoutubePlayer.prototype, "onStateChanged", null);
    __decorate([
        Watch("YTPlayerState"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], YoutubePlayer.prototype, "onYTPlayerStateChange", null);
    YoutubePlayer = __decorate([
        Component
    ], YoutubePlayer);
    return YoutubePlayer;
}(Vue));
export default YoutubePlayer;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ThePlayer/YoutubePlayer.vue
// module id = 273
// module chunks = 0